<div class="coin-purse">
  <img src="assets/img/coin/coin_purse.png" alt="" />
  <p>{{ coinPurseObs$ | async }}</p>
</div>
